import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { CentralServiceResources as cs } from 'se-resource-types'

@Component({
  selector: 'se-setup-membership',
  templateUrl: './setup-membership.component.html',
  styleUrls: ['./setup-membership.component.scss'],
  standalone: false,
})
export class SetupMembershipComponent implements OnInit {

  public footerYear = new Date().getFullYear()
  public logo: string
  public returnTo: string

  constructor(
    public analyticsService: AnalyticsService,
    public setupService: SetupBarService,
    private route: ActivatedRoute
  ) { }

  public ngOnInit() {
    this.logo = `${environment.uiThemes}/assets/latest/images/sportsengine-logo-color-black.svg`
    this.route.queryParams
      .subscribe(params => {
        const app = params.returnApp
        const path = params.returnPath || ''
        const qs = params.returnQs ? `?${params.returnQs}` : ''
        this.returnTo = `${environment.returnUrls[app]}${path}${qs}`
      })
  }

  public onPick(profile: cs.Households.UserProfile): void {
    const [url, qs] = this.returnTo.split('?')
    const returnUrl = `${url}/${profile.persona.id}`
    window.location.href = qs ? `${returnUrl}?${qs}` : returnUrl
  }
}
